module.exports = __webpack_public_path__ + "static/media/shark.16aa33e8.svg";